import type { Plugin } from 'vue';

import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';

import type { AppModule } from './AppModule';

const AppModulePlugin: Plugin<{
  router: AppVueRouter;
  modules: AppModule[];
  menu: AppMenu;
  translationsMapper: TranslationKeysMapper;
}> = {
  install(app, {
    router,
    modules,
    menu,
    translationsMapper,
  }) {
    for (const module of modules) {
      module.install({ router, menu, translationsMapper });
    }

    app.use(router);
  },
};

export default AppModulePlugin;
